import camera from "../../images/camera.png";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import { Dialog, Popover } from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import useWindowDimensions from "../../CustomHooks/useWindowdimension";
import { data } from "./data";
import axios from "axios";
import {
  DialogTitle,
  TextField,
  TextareaAutosize,
  Typography,
} from "@mui/material";
import Button from "../ResubleComp/Button";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ChatState } from "../../ChatApp/Context/ChatProvider";
const ExploreCluster = ({
  opencluster,
  clusterClose,
  CloseIcon,
  clusterHandler,
  // baseUrl,
  setPosts,
  filter,
  setFilter,
  posts,
}) => {
  const { height, width } = useWindowDimensions();
  const token = localStorage.getItem("TOKEN");
  const navigate = useNavigate();
  const [clusterName, setClusterName] = useState("");
  const [clusterProfileImage, setClusterImage] = useState("");
  const [clusterGuideLines, setClusterGuideLines] = useState("");
  const [aboutCluster, setAboutCluster] = useState("");
  const [cluster, setCluster] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [clusterData, setClusterData] = useState(null);

  const { user } = ChatState();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const createCluster = async () => {
    const formData = new FormData();
    formData.append("name", clusterName);
    formData.append("clusterProfileImage", clusterProfileImage);
    formData.append("clusterGuideLines", clusterGuideLines);
    formData.append("aboutCluster", aboutCluster);
    const createUrl = `${baseUrl}/api/cluster/create`;
    const response = await axios.post(createUrl, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        authorization: token,
      },
    });
    console.log("clustresponse", response);
    localStorage.setItem("clusterId", response.data.name);

    if (response.status === 201) {
      navigate("/yourcluster");
    }
  };

  // /api/cluster/allClusters
  const getAllCluster = async () => {
    const urls = baseUrl + `/api/cluster/allClusters`;
    const response = await axios.get(urls, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("getallclusterres", response);
    const userId = localStorage.getItem("userId");
    const newArr = [];
    const res = response.data.filter((name, index) => {
      if (name.createdBy.user === userId) {
        newArr.push(name);
        setCluster(newArr);
        console.log("newarrr", newArr);
      } else {
        console.log("nhi chla yaar");
      }
    });
    console.log("res", res);
    return res;
  };
  useEffect(() => {
    getAllCluster();
  }, []);

  const redirectToClusterPage = async (clusterName) => {
    localStorage.setItem("clusterId", clusterName);
    const urls = baseUrl + `/api/cluster/getclusterbyname/${clusterName}`;
    const response = await axios.get(urls, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    navigate(`/yourcluster`);
    console.log("responseseee", response);
    return response;
  };

  // to="/yourcluster"

  const openPopUp = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClosed = () => {
    setAnchorEl(null);
  };
  const openpop = Boolean(anchorEl);
  const id = openpop ? "simple-popover" : undefined;
  console.log("dataaaa", cluster);

  return (
    <>
      <Popover
        id={id}
        open={openpop}
        anchorEl={anchorEl}
        onClose={handleClosed}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <ul className="px-3 py-3 flex flex-col gap-2">
          {cluster?.map((data) => {
            return (
              <li className="cursor-pointer border-2 border-gray-800 rounded-md px-1 py-1 hover:bg-slate-300">
                <Typography
                  onClick={() => {
                    redirectToClusterPage(data.name);
                  }}
                  value={data.name}
                >
                  {data.name}
                </Typography>
              </li>
            );
          })}
        </ul>
        <br />
      </Popover>

      <Card className="p-2">
        <Box>
          <div className="mb-2 text-center text-lg">Explore Clusters</div>
          <TextField
            fullWidth
            label="Search Clusters"
            id="fullWidth"
            variant="outlined"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          />
          <div className="flex flex-col">
            {token && cluster.length > 0 ? (
              <Button
                onClick={openPopUp}
                className="mt-4 bg-blue-500 text-white rounded-md hover:bg-blue-300 py-2"
              >
                Your Clusters
              </Button>
            ) : (
              <Typography className="mt-4 py-2 text-center">
                Your Clusters will be shown here
              </Typography>
            )}
            <Typography sx={{ textAlign: "center", marginTop: "20px" }}>
              Suggested For you
            </Typography>
            {/* {cluster} */}
          </div>
        </Box>
        <Box sx={{ p: 1, m: 2, display: "flex", flexWrap: "wrap", gap: 1 }}>
          {data.map((item) => (
            <Button
              key={item.value}
              onClick={() => redirectToClusterPage(item.value)}
              className="px-1 py-1 text-black hover:text-white
                rounded-md border-blue-500 border-2
              "
            >
              {item.label}
            </Button>
          ))}
        </Box>

        <Dialog
          open={opencluster}
          onClose={clusterClose}
          sx={{ width: "100vw" }}
        >
          <DialogTitle align="center" color="#258480" fontSize="bold">
            <Box display="flex" justifyContent="flex-end">
              <Typography justify="flex-end">
                <CloseIcon onClick={clusterClose} sx={{ cursor: "pointer" }} />
              </Typography>
            </Box>
          </DialogTitle>

          <Typography
            variant="h4"
            textAlign="center"
            sx={{ fontSize: width > 768 ? "39px" : "32px" }}
          >
            Create a cluster
          </Typography>
          <DialogContent>
            <Card
              // title="select image"
              // className="image-uploads"
              // sx={{ ml: 1, p: 1 }}
              style={{
                width: width > 768 ? "552px" : width > 450 ? "76vw" : "70vw",
              }}
            >
              {clusterProfileImage ? (
                <label htmlFor="file-input">
                  <img
                    src={URL.createObjectURL(clusterProfileImage)}
                    alt=""
                    className="rounded-full w-[100px] h-[100px] border-2 cursor-pointer"
                  />
                </label>
              ) : (
                <label htmlFor="file-input">
                  <img
                    src={camera}
                    alt=""
                    className="rounded-full w-[100px] h-[100px] border-2 cursor-pointer"
                  />
                </label>
              )}
              <input
                id="file-input"
                style={{ display: width > 800 ? "none" : "block" }}
                type="file"
                onChange={(e) => setClusterImage(e.target.files[0])}
              />
            </Card>

            <span className="ml-5">Upload Image</span>
            <TextField
              // fullWidth
              className="w-full"
              label="Enter Your Topic"
              placeholder="Keep it on academic or career related"
              variant="outlined"
              sx={{ m: 1 }}
              maxLength={10}
              onChange={(e) => setClusterName(e.target.value)}
              value={clusterName}
            />
            <TextField
              fullWidth
              label="Guidelines"
              placeholder="How do you want the members to interact"
              variant="outlined"
              sx={{ m: 1 }}
              onChange={(e) => setClusterGuideLines(e.target.value)}
              value={clusterGuideLines}
            />
            <TextareaAutosize
              autoFocus
              minRows={5}
              minLength={10}
              maxLength={200}
              value={aboutCluster}
              onChange={(e) => setAboutCluster(e.target.value)}
              placeholder="Tell the objective to the members"
              style={{
                width: width > 768 ? "552px" : "100%",
                padding: "5px",
                border: "2px solid #EAE0DA",
                marginLeft: "8px",
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={createCluster}
              primary
              className="px-5 py-3 rounded-md"
            >
              create
            </Button>
          </DialogActions>
        </Dialog>
        <div className="flex justify-center">
          <Button
            onClick={clusterHandler}
            primary
            className=" px-5 py-3 rounded-md w-full cursor-pointer"
          >
            Create Cluster
          </Button>
        </div>
      </Card>
    </>
  );
};
export default ExploreCluster;
